const BASE_URL = process.env.REACT_APP_BACKEND_URL
const BASE_AUTH_URL = `${BASE_URL}auth/`
const LOGIN_URL = `${BASE_AUTH_URL}token/`
const FORGOT_PASSWORD_URL = `${BASE_AUTH_URL}password-reset/`
const RESET_PASSWORD_URL = `${BASE_AUTH_URL}password-reset/confirm/`
const REFRESH_TOKEN_URL = `${BASE_AUTH_URL}token/refresh/`
const GET_USER_DETAILS = `${BASE_URL}users/`

export default {
  LOGIN_URL,
  FORGOT_PASSWORD_URL,
  REFRESH_TOKEN_URL,
  RESET_PASSWORD_URL,
  GET_USER_DETAILS,
}
